const decrementListIndex = (index) => {
	return index > 0 ? index - 1 : undefined
}

const incrementListIndex = (index, maxValue) => {
	return index === maxValue ? index : index + 1 || 0
}

export { decrementListIndex, incrementListIndex }
